<template>
    <modal
        name="reporting-user-table"
        height="auto"
        width="90%"
        :maxWidth="1460"
        :adaptive="true"
        :scrollable="true"
    >
        <div class="modal">
            <UserTableSummary :user="memberDetails"/>
            <ActiveFilters :filters="filters" :filterStaticData="filterStaticData" />
            <UserTable :data="memberCourses" />
            <span class="modal__table-items-amount" v-html="getTableItemAmount"></span>
            <TotemButton
                @click="$modal.hide('reporting-user-table')"
                class="modal__close-button"
                :label="$t('General.close')"
            />
       </div>
    </modal>
</template>

<script>
    import UserTable from 'components/user/organizationreport/tabs/users/tables/UserTable'
    import UserTableSummary from 'components/user/organizationreport/tabs/users/modal/UserTableSummary'
    import ActiveFilters from 'components/user/organizationreport/filters/ActiveFilters'

    import { mapGetters } from 'vuex'

    export default {
        components: {
            UserTable,
            UserTableSummary,
            ActiveFilters
        },
        computed: {
            ...mapGetters({
                memberDetails: 'ReportsUsers/getMemberDetails',
                memberCourses:  'ReportsUsers/getMemberCourses',
                filters: 'ReportsUsers/filters',
                filterStaticData: 'ReportsUsers/getFilterStaticData'
            }),
            isWatchListNameEmpty () {
                return this.newWatchlistName === '' && this.addInProgress
            },
            getTableItemAmount () {
                return this.$t('OrganizationReport.total_of_courses', { itemsLength: this.memberCourses.length })
            }
        }
    }
</script>

<style lang="scss" scoped>
.modal {
    padding: 30px;
    display: flex;
    flex-direction: column;

    &__close-button {
        align-self: center;
        margin: 30px 0 0;
    }

    &__table-items-amount {
        font-family: Nunito-Regular, sans-serif;
        font-size: 1.6rem;
        color: $emperor;
        margin: 10px 10px 0;
    }
}
</style>
